export default __webpack_public_path__ + "static/promo-3487895ed0fe51c910031b8acc0ae941.png";